module.exports = __webpack_public_path__ + "img/blueSapphireRings@2x.df0f7c0.webp";